import { useEffect, useState } from "react";
import styles from "../styles/settingsGeneralDetails.module.css";

// Reusable component for Yes/No radio buttons
export const SettingsDayHoursComponent = ({
  formData,
  updates,
  setUpdates,
  setFormData,
  day,
  handleTimeChange,
  isExperience = false,
}: {
  formData: any;
  updates: any;
  setUpdates: any;
  setFormData: any;
  day: string;
  handleTimeChange: Function;
  isExperience: Boolean;
}) => {
  const [dropdownMadeHours, setDropdownMadeHours] = useState("temp");
  const [hoursSelect, setHoursSelect] = useState(false);

  // useEffect(() => {
  //   if (formData[`${day}Hours`] !== "closed" && formData[`${day}Hours`] !== "open 24 hours") {
  //     setHoursSelect(true);
  //   }
  //   console.log("formdata in settingsDayHoursComponent", formData);
  //   console.log("updates in settingsDayHoursComponent", updates);
  // }, [])
  useEffect(() => {
    if (formData[`${day}Hours`] !== "closed" && formData[`${day}Hours`] !== "open 24 hours") {
      setHoursSelect(true);
    }
  }, [formData, day, updates]);

  const handleBoolChange = (e: any) => {
    const { name, value, type } = e.target;
    console.log("boolchange target", e.target);

    if (value === "closed" || value === "open 24 hours") {
      setHoursSelect(false);
      //remove the helper variables if we use just above value instead of creating timestring
      delete updates[`${day}Start`];
      delete updates[`${day}End`];
      delete updates[`${day}StartAmPm`];
      delete updates[`${day}EndAmPm`];
      setUpdates((prev: any) => ({
        ...prev,
        [`${day}Hours`]: value,
      }));
    } else {
      setHoursSelect(true);
    }
    setFormData((prev: any) => ({
      ...prev,
      [`${day}Hours`]: value,
    }));
  };

  const startTimeKey = `${day}Start`;
  const endTimeKey = `${day}End`;
  const startTimeAmPmKey = `${day}StartAmPm`; // Key for start time AM/PM
  const endTimeAmPmKey = `${day}EndAmPm`; // Key for end time AM/PM

  // Assuming you split the time and AM/PM in your formData
  const startTimeValue = updates[startTimeKey]; //formData[startTimeKey] ? formData[startTimeKey].split(' ')[0] : '';
  const endTimeValue = updates[endTimeKey]; //? formData[endTimeKey].split(' ')[0] : '';

  const startTimeAmPmValue = updates[startTimeAmPmKey] || "AM"; // Default to AM
  const endTimeAmPmValue = updates[endTimeAmPmKey] || "PM"; // Default to PM

  const generateTimeOptions = () => {
    const options = []; //["closed", "open 24 hours"]; not having these options in dropdown list
    for (let hour = 0; hour < 12; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = `${hour % 12 === 0 ? 12 : hour % 12}:${minute === 0 ? "00" : minute}`;
        options.push(time);
      }
    }
    return options;
  };
  const timeOptions = generateTimeOptions();

  const handleFocus = () => {
    console.log("Input focused");
  };

  const handleBlur = () => {
    console.log("Input blurred");
  };

  return (
    <div style={{ marginTop: 20 }} className={styles.categorySelect}>
      {
        <label>
          {day[0].toUpperCase()}
          {day.slice(1)}
        </label>
      }
      <div>
        {!isExperience && (
          <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
            <div className={styles.hourOptions}>
              <div
                className={
                  // active if checked
                  formData[`${day}Hours`] === "open 24 hours"
                    ? `${styles.radioButtonWrapper} ${styles.active}`
                    : styles.radioButtonWrapper
                }
                onClick={() => handleBoolChange({ target: { value: "open 24 hours" } })}
              >
                <input
                  type="radio"
                  id={`${day}Open24Hours`}
                  name={`${day}Hours`}
                  value={"open 24 hours"}
                  checked={formData[`${day}Hours`] === "open 24 hours"}
                  onChange={handleBoolChange}
                  className={styles.hiddenRadioButton}
                />
                <label htmlFor={`${day}Open24Hours`} className={styles.radioButtonLabel}>
                  open 24 hours
                </label>
              </div>
            </div>
            <div className={styles.hourOptions}>
              <div
                className={
                  // active if checked
                  formData[`${day}Hours`] === "closed"
                    ? `${styles.radioButtonWrapper} ${styles.active}`
                    : styles.radioButtonWrapper
                }
                onClick={() => handleBoolChange({ target: { value: "closed" } })}
              >
                <input
                  type="radio"
                  id={`${day}Closed`}
                  name={`${day}Hours`}
                  value={"closed"}
                  checked={formData[`${day}Hours`] === "closed"}
                  onChange={handleBoolChange}
                  className={styles.hiddenRadioButton}
                />
                <label htmlFor={`${day}Closed`} className={styles.radioButtonLabel}>
                  closed
                </label>
              </div>
            </div>
            <div className={styles.hourOptions}>
              <div
                className={
                  // active if checked
                  formData[`${day}Hours`] !== "closed" && formData[`${day}Hours`] !== "open 24 hours"
                    ? `${styles.radioButtonWrapper} ${styles.active}`
                    : styles.radioButtonWrapper
                }
                onClick={() => handleBoolChange({ target: { value: dropdownMadeHours } })}
              >
                <input
                  type="radio"
                  id={`${day}OpenBetweenHours`}
                  name={`${day}Hours`}
                  value={dropdownMadeHours}
                  checked={formData[`${day}Hours`] !== "closed" && formData[`${day}Hours`] !== "open 24 hours"}
                  onChange={handleBoolChange}
                  className={styles.hiddenRadioButton}
                />
                <label htmlFor={`${day}OpenBetweenHours`} className={styles.radioButtonLabel}>
                  open between hours:
                </label>
              </div>
            </div>
          </div>
        )}
        {((formData[`${day}Hours`] !== "open 24 hours" && formData[`${day}Hours`] !== "closed") || isExperience) && (
          <div
            style={{
              marginTop: -20,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 0,
            }}
          >
            <div key={day}>
              <div style={{ marginTop: 20 }}>
                <div style={{ display: hoursSelect ? "block" : "none" }}>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    {/* Start Time Dropdown */}
                    <select
                      style={{ padding: 10 }}
                      name={startTimeKey}
                      value={startTimeValue}
                      onChange={(e) => handleTimeChange(e)}
                      className={styles.timeInputWidth}
                    >
                      <option value="">Select Start Time</option>
                      {timeOptions.map((time) => (
                        <option
                          key={`${day}-start-${time}`}
                          value={time === "open 24 hours" ? time : time.split(" ")[0]}
                        >
                          {time === "open 24 hours" ? time : time.split(" ")[0]}
                        </option>
                      ))}
                    </select>
                    {/* Start Time AM/PM Selector */}
                    <select
                      style={{ padding: 10 }}
                      name={startTimeAmPmKey}
                      value={startTimeAmPmValue}
                      onChange={(e) => handleTimeChange(e)}
                      className={styles.meridianInput}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                    {/* End Time Dropdown */}
                    <select
                      style={{ padding: 10 }}
                      name={endTimeKey}
                      value={endTimeValue}
                      onChange={(e) => handleTimeChange(e)}
                      className={styles.timeInputWidth}
                    >
                      <option value="">Select End Time</option>
                      {timeOptions.map((time) => (
                        <option key={`${day}-end-${time}`} value={time === "open 24 hours" ? time : time.split(" ")[0]}>
                          {time === "open 24 hours" ? time : time.split(" ")[0]}
                        </option>
                      ))}
                    </select>
                    {/* End Time AM/PM Selector */}
                    <div>
                      <select
                        style={{ padding: 10 }}
                        name={endTimeAmPmKey}
                        value={endTimeAmPmValue}
                        onChange={(e) => handleTimeChange(e)}
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
